import {get,post,put} from '@/api/request.js'

/**
 * 获取更新通知
 * @param page
 * @param page_size
 * @returns {Promise<void>}
 */
export const get_update_notice = async function (page, page_size) {
    return await get('/admin/update/record',{
        params: {page, page_size}
    })
}

/**
 * 新增更新通知
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const add_update_notice = async function (data) {
    return await post('/admin/update/record',{
        data
    })
}

/**
 * 修改更新通知
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const put_update_notice = async function (data) {
    return await put('/admin/update/record',{
        data,
    })
}

/**
 * 获取最新一次通知
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const get_new_notice = async function () {
    return await get('/admin/new/update/record',{
        headers: {
            'x-ignore-interceptor': 'true' // 标识该请求跳过拦截器
          }
    })
}
